// extracted by mini-css-extract-plugin
export default {"floatButton":"FloatButton_floatButton__yV2W4"};